var React = require('react');

function EyeIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M12.09,15.94c-2.15,0-3.9-1.77-3.9-3.95c0-2.18,1.75-3.95,3.9-3.95s3.9,1.77,3.9,3.95\n\t\tC15.99,14.17,14.24,15.94,12.09,15.94z M12.09,9.54c-1.32,0-2.4,1.1-2.4,2.45c0,1.35,1.08,2.45,2.4,2.45s2.4-1.1,2.4-2.45\n\t\tC14.49,10.64,13.41,9.54,12.09,9.54z"})),React.createElement("path",{"d":"M21.81,11.44c-2.4-3.13-5.01-4.83-7.74-5.69c-1.14-0.28-2.36-0.35-3.72-0.09c-2.9,0.59-5.63,2.63-8.22,5.85\n\tc-0.21,0.39-0.18,0.76,0.15,1.12c6.7,7.98,13.14,7.64,19.34,0.09C22.08,12.22,22.1,11.8,21.81,11.44z M3.44,12\n\tc5.6-6.73,11.27-7.04,17.03,0C14.89,18.81,9.22,18.86,3.44,12z","key":1})]);
}

EyeIcon.defaultProps = {"data-dmid":"dm-eye","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","fill":"currentColor","pointerEvents":"none","color":"color2"};

module.exports = EyeIcon;

EyeIcon.default = EyeIcon;
